import { ProductoAmazon } from "@/shared/dtos/productosAmazon/ProductoAmazon";
import { clients } from "@/shared/dtos/clients";

/**
 * Item del carrito: contiene el producto y la cantidad
 */
export class CartItem {
  public product: ProductoAmazon;
  public qty: number;

  constructor(data?: Partial<CartItem>) {
    if (data && data.product) {
      this.product = new ProductoAmazon(data.product as any);
    } else {
      this.product = new ProductoAmazon() as any;
    }

    if (data && typeof data.qty !== "undefined" && data.qty !== null) {
      this.qty = data.qty;
    } else {
      this.qty = 1;
    }
  }

  get productId(): number | undefined {
    return this.product ? (this.product as any).id : undefined;
  }

  get lineTotal(): number {
    var precio = 0;
    if (this.product && typeof (this.product as any).precio_venta !== "undefined") {
      precio = Number((this.product as any).precio_venta);
    }
    return precio * this.qty;
  }

  public toPlain() {
    var plain: any = {
      product: this.product ? { ...(this.product as any) } : {},
      qty: this.qty
    };
    return plain;
  }
}
